<template>
	<div>
		<div class="notifications-wrapper">
			<div 
			class="notification-item shadowed" 
			@click="dismiss(item)"
			v-for="(item, idx) in list" 
			:key="idx"
			:class="{
				'error': (item.type == 'error'),
				'success': (item.type == 'success')
			}"
			>
				{{ item.text }}
				
				<button class="notification-dismiss">
					<i class="fa fa-times"></i>
				</button>

			</div>
		</div>
	</div>
</template>


<script>
	export default {
		name: "Notification",

		data: function() {
			return this.$notification.data;
		},

		methods: {
			dismiss: function(item) {
				for (let idx in this.list) {
					if (this.list[idx] == item) {
						if (this.list[idx].callback != false) {
							this.list[idx].callback();
						}

						this.list.splice(idx, 1);
					}
				}
			}
		}
	}
</script>


<style scoped>

.notifications-wrapper {
	width: 350px;
	max-height: 100vh;
	overflow: hidden;
	position: fixed;
	top: 0;
	right: 0;
	padding-bottom: 15px;
	z-index: 999;
}

.notification-item {
	position: relative;
	float: left;
	width: calc(100% - 30px);
	margin-left: 15px;
	margin-right: 15px;
	margin-top: 15px;
	background: #333;
	color: #fff;
	padding: 15px;
	padding-right: 40px;
	font-size: 14px;
	font-weight: bold;
	border-radius: 4px;
	cursor: pointer;
}
.notification-item:hover {
	opacity: 0.8;	
}


.notification-item.error {
	background: #ec1313;
}

.notification-item.success {
	background: #0f6e0f;
}


.notification-dismiss {
	position: absolute;
	right: 14px;
	top: 14px;
	color: #ddd;
	background: none;
	border: none
}
</style>
